export default "__VITE_ASSET__BpHmytRP__"